import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "tip-bar d-flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "tip-bar__icon d-flex align-items-center justify-content-center"
}
const _hoisted_3 = { class: "tip-bar__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tip.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.tip.icon)
          }, null, 2)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["tip-bar__icon-content d-flex align-items-center justify-content-center", _ctx.tip.iconConfig?.type])
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.tip.iconConfig?.icon)
          }, null, 2)
        ], 2)),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.tip.title), 1),
    (_ctx.tip.tip)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "tip-bar__link ms-3 d-flex align-items-center saiba-mais-integracao-potencial__ga",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.activeLink && _ctx.activeLink(...args)))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-long-arrow-right" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.tip.tip), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.close)
      ? (_openBlock(), _createElementBlock("i", {
          key: 3,
          class: "tip-bar__close icon-nave-close ms-auto me-4",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeTip && _ctx.closeTip(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}